import { IMunicipioIBGE } from "../interfaces/IMunicipioIBGE";
import api from "./Api";
import Swal from 'sweetalert2';

class IBGEService {

  async pesquisarMunicipios(UF: string, funcaoSucesso?: (data: IMunicipioIBGE[]) => void, textoPopupSucesso?: string): Promise<boolean> {
    try {
      const { data: result } = await api.get<IMunicipioIBGE[]>(`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${UF}/municipios`);

      funcaoSucesso && funcaoSucesso(result);
  
      textoPopupSucesso && Swal.fire({
        text: textoPopupSucesso,
        timer: 3000,
        icon: 'success',
        showConfirmButton: false
      });
      
      return true;
    } catch (error: any) {
      Swal.fire({
        text: error.message,
        timer: 4000,
        icon: 'error',
        showConfirmButton: false
      });
  
      return false;
    }
  }
}

export default new IBGEService();